import * as React from 'react';
import { Translate } from '../../shared/LanguageService';

interface IGoogleMapsLink {
    id?: string;
    streetAddress?: string;
    zip?: string;
    city?: string;
    className?: string;
    children?: React.ReactNode;
}
const GoogleMapsLink = (props: IGoogleMapsLink) => {
    let googleMapsData = null;
    const regex = /(\d+([?!\s]*)t[(?!r)]+\s*)/;

    const concatGoogleMapsData = (data: IGoogleMapsLink) => {
        let internalGoogleMapsData = '';

        if (data.streetAddress) {
            internalGoogleMapsData = data.streetAddress;
        }

        if (data.zip) {
            internalGoogleMapsData += ',+' + data.zip.replace(' ', '+');
        }

        if (data.city) {
            internalGoogleMapsData += '+' + data.city.replace(' ', '+');
        }

        return internalGoogleMapsData;
    };

    if (props.streetAddress || props.zip || props.city) {
        googleMapsData = concatGoogleMapsData(props);
    }

    return (
        <span>
            <a
                href={
                    'https://www.google.com/maps/place/' +
                    (googleMapsData
                        ? window.encodeURI(googleMapsData.replace(regex, ''))
                        : props.children
                        ? window.encodeURI(props.children.toString().replace(regex, ''))
                        : '')
                }
                target="_blank"
                id={props.id}
                className={props.className ? props.className + ' ' : ''}
                title={Translate('components/common/google-maps-link/achor-title')}
            >
                {props.children}
            </a>
        </span>
    );
};

export default GoogleMapsLink;
